export default __webpack_public_path__ + "static/media/titre.d3cf5f9f.svg";